"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Menu = void 0;
var React = _interopRequireWildcard(require("react"));
var _core = require("@dnd-kit/core");
var _sortable = require("@dnd-kit/sortable");
var _DraggableMenu = _interopRequireDefault(require("./DraggableMenu"));
var _SortableMenuItem = _interopRequireWildcard(require("./SortableMenuItem"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var defaultProps = {
  actionFooter: true,
  menuListId: 'menu-id',
  menuItems: []
};
var Menu = /*#__PURE__*/function (_React$Component) {
  _inherits(Menu, _React$Component);
  var _super = _createSuper(Menu);
  function Menu(props) {
    var _this;
    _classCallCheck(this, Menu);
    _this = _super.call(this, props);
    _defineProperty(_assertThisInitialized(_this), "debounced", function (delay, fn) {
      var timerId;
      return function () {
        for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }
        if (timerId) {
          clearTimeout(timerId);
        }
        timerId = setTimeout(function () {
          fn.apply(void 0, args);
          timerId = null;
        }, delay);
      };
    });
    _defineProperty(_assertThisInitialized(_this), "onResizeMultiSelection", function () {
      _this.setState({
        showFromIndex: 0,
        optionAdded: true
      });
    });
    //Drag Events start
    _defineProperty(_assertThisInitialized(_this), "findIndex", function (id) {
      return _this.props.menuItems.findIndex(function (item) {
        return item.id === id;
      });
    });
    _defineProperty(_assertThisInitialized(_this), "handleDragStart", function (_ref) {
      var active = _ref.active;
      _this.setState({
        dragItem: _this.findIndex(active.id)
      });
    });
    _defineProperty(_assertThisInitialized(_this), "handleDragEnd", function (event) {
      var active = event.active,
        over = event.over;
      var items = _toConsumableArray(_this.props.menuItems);
      if (over && active) {
        if (active.id !== over.id) {
          var oldIndex = _this.findIndex(active.id);
          var newIndex = _this.findIndex(over.id);
          items = (0, _sortable.arrayMove)(items, oldIndex, newIndex);
        }
      }
      _this.setState({
        dragItem: -1
      });
      _this.props.onChange && _this.props.onChange(items);
    });
    _defineProperty(_assertThisInitialized(_this), "renderItemContent", function (item, index) {
      return _this.props.MenuItemComponent ? _this.props.MenuItemComponent(item, index, _this.highlightMatch(item.displayText, item.itemId)) : _this.highlightMatch(item.displayText, item.itemId);
    });
    _defineProperty(_assertThisInitialized(_this), "handleDragLeave", function (e) {
      e.stopPropagation();
    });
    _defineProperty(_assertThisInitialized(_this), "handleClickOutside", function (event) {
      var parentElem = document.getElementById("".concat(_this.props.menuListId, "-container"));
      var button = document.getElementById("".concat(_this.props.buttonId));
      if (parentElem && !parentElem.contains(event.target) && button && !button.contains(event.target)) {
        if (_this.props.onClickOutSide) {
          _this.props.onClickOutSide(event);
        } else {
          _this.closeMenuList();
        }
      }
    });
    _defineProperty(_assertThisInitialized(_this), "onOptionClick", function (event, option) {
      if (!option) {
        var dataItem = event.target.getAttribute('data-item');
        option = _this.props.menuItems.find(function (item) {
          return item.itemId === dataItem;
        });
      }
      if (_this.props.onOptionClick) {
        var inputElem = _this.props.btnRef ? _this.props.btnRef : document.getElementById(_this.props.menuListId);
        inputElem && inputElem.focus();
        _this.props.onOptionClick(event, option);
      } else _this.closeMenuList();
    });
    _defineProperty(_assertThisInitialized(_this), "onListKeyDown", function (event) {
      // Enter or space selects an option and returns focus to the textbox
      if (event.key === "Enter" || event.key === " " || event.key === "Space") {
        _this.onOptionClick(event);
        var inputElem = document.getElementById(_this.props.menuListId);
        inputElem && inputElem.focus();
      }
      // Arrow keys navigate through selectable menuItems
      // Up arrow on first option returns focus to the textbox (but doesn't close list)
      if (event.key === "ArrowDown") {
        event.preventDefault();
        var targetElem = event.target.nextSibling;
        if (!targetElem) {
          targetElem = event.target.parentElement.firstChild;
        }
        targetElem && targetElem.focus();
      }
      if (event.key === "ArrowUp") {
        event.preventDefault();
        var _targetElem = event.target.previousSibling;
        _targetElem && _targetElem.focus();
        if (!_targetElem) {
          var _inputElem = document.getElementById(_this.props.menuListId);
          _inputElem && _inputElem.focus();
        }
      }
      if (event.key === 'Escape' || event.key === 'Esc' || event.keyCode === 27) {
        var _inputElem2 = document.getElementById(_this.props.menuListId);
        _inputElem2 && _inputElem2.focus();
        _this.closeMenuList();
      }

      // When we tab out, close the MenuList
      if (event.key === "Tab") {
        var _targetElem2 = event.target.nextSibling;
        while (_targetElem2 && _targetElem2.getAttribute("tabindex") !== "-1") {
          _targetElem2 = _targetElem2.nextSibling;
        }
        _targetElem2 && _targetElem2.focus();
      }
    });
    _defineProperty(_assertThisInitialized(_this), "onKeyDown", function (event) {
      var _document$getElementB;
      if (event.key === "Enter" || event.key === " " || event.key === "Space") {
        _this.toggleMenuList();
      }
      if (event.key === 'Escape' || event.key === 'Esc' || event.keyCode === 27) {
        if (_this.state.isOpen) {
          var inputElem = document.getElementById(_this.props.menuListId);
          inputElem !== null && inputElem.focus();
          _this.closeMenuList();
        }
      }
      var menuListContent = document.getElementById(_this.props.menuListId + "-menu-list-options");
      if (event.key === "ArrowDown" && menuListContent !== null) {
        var children = menuListContent.children;
        for (var i = 0; i < children.length; i += 1) {
          if (children[i].getAttribute('tabindex') === '-1') {
            var childElement = document.getElementById(children[i].id);
            childElement !== null && childElement.focus();
            break;
          }
        }
      }
      var tagList = (_document$getElementB = document.getElementById(_this.props.menuListId)) === null || _document$getElementB === void 0 ? void 0 : _document$getElementB.querySelectorAll('.tl-tag-value');
      if (event.key === "ArrowRight" && tagList !== null && tagList !== void 0 && tagList.length) {
        var firstElement = tagList[0];
        _this.assignFocusTo(firstElement);
      }
      if (event.keyCode === 37 && tagList !== null && tagList !== void 0 && tagList.length) {
        var lastElement = tagList[tagList.length - 1];
        lastElement && lastElement.focus();
      }

      // When we tab out, close the menuList
      if (event.key === "Tab") {
        _this.closeMenuList();
      }
      if (_this.props.onKeyDown) {
        _this.props.onKeyDown(event);
      }
    });
    _defineProperty(_assertThisInitialized(_this), "toggleMenuList", function () {
      if (_this.state.isOpen) {
        _this.closeMenuList();
      } else _this.setState({
        isOpen: true,
        menuListUntouched: false
      });
      if (_this.props.onClick) {
        _this.props.onClick(!_this.state.isOpen);
      }
    });
    _defineProperty(_assertThisInitialized(_this), "closeMenuList", function () {
      if (_this.state.isOpen) {
        _this.setState({
          isOpen: false
        });
      }
      if (_this.props.buttonId && _this.props.selectedDropdown) {
        _this.props.selectedDropdown(null, _this.props.buttonId);
      }
    });
    _defineProperty(_assertThisInitialized(_this), "assignFocusTo", function (element) {
      element && element.focus();
    });
    _this.state = {
      isOpen: true,
      menuListUntouched: true,
      showFromIndex: 0,
      optionAdded: false,
      // menuItems: [],
      dragItem: -1
    };
    return _this;
  }
  _createClass(Menu, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      document.addEventListener('mousedown', this.handleClickOutside);
      window.addEventListener('resize', this.debounced(500, this.onResizeMultiSelection));
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      document.removeEventListener('mousedown', this.handleClickOutside);
      window.removeEventListener('resize', this.debounced(500, this.onResizeMultiSelection));
    }
  }, {
    key: "render",
    value: function render() {
      var renderAbove = false;
      var parentElem = document.getElementById(this.props.menuListId);
      var className = [this.props.className];
      if (parentElem) {
        renderAbove = this.props.forceOpenToward === 'up';
      }
      if (this.props.draggable) {
        className = className.concat('tl-draggable-menu');
      }
      return /*#__PURE__*/React.createElement("div", {
        id: "".concat(this.props.menuListId, "-container"),
        className: "".concat(className.join(' '), " tl-menu-list")
      }, /*#__PURE__*/React.createElement("div", {
        id: this.props.menuListId + "-menu-list-content",
        tabIndex: 0,
        className: "".concat(this.props.optionClassName, " tl-menu-list-options ").concat(!this.state.isOpen && "tl-menu-list-closed", " ").concat(renderAbove && 'tl-menu-list-above')
      }, /*#__PURE__*/React.createElement("div", {
        id: this.props.menuListId + "-menu-list-options",
        className: 'tl-menu-list-options-list'
      }, this.renderOptions())));
    }
  }, {
    key: "highlightMatch",
    value: function highlightMatch(label, itemId) {
      return /*#__PURE__*/React.createElement("span", {
        id: "".concat(itemId, "-text"),
        "data-item": label
      }, label);
    }
  }, {
    key: "renderOptions",
    value:
    //Drag Events end

    function renderOptions() {
      var _this2 = this;
      var dragItem = this.state.dragItem;
      var menuItems = this.props.menuItems;
      if (this.props.menuItems.length === 0) {
        return /*#__PURE__*/React.createElement("div", {
          className: "tl-menu-list-disabled-option test"
        }, 'There are no results');
      }
      if (this.props.draggable) {
        return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(_DraggableMenu.default, {
          onDragStart: this.handleDragStart,
          onDragEnd: this.handleDragEnd
        }, /*#__PURE__*/React.createElement(_sortable.SortableContext, {
          items: menuItems,
          strategy: _sortable.verticalListSortingStrategy
        }, menuItems.map(function (item, index) {
          var value = _this2.renderItemContent(item, index);
          return /*#__PURE__*/React.createElement(_SortableMenuItem.default, {
            key: item.id,
            disabled: item.pinned,
            className: 'tl-draggable',
            itemClassName: "".concat(dragItem >= 0 ? '-drag-start' : ''),
            value: value,
            handle: true,
            id: item.id
          });
        }), dragItem >= 0 && /*#__PURE__*/React.createElement(_core.DragOverlay, {
          className: "tl-overlay",
          adjustScale: true
        }, /*#__PURE__*/React.createElement(_SortableMenuItem.Item, {
          handle: true,
          value: this.renderItemContent(menuItems[dragItem], dragItem),
          className: 'tl-overlay-item'
        })))), this.props.actionFooter && /*#__PURE__*/React.createElement("div", {
          className: "tl-actions"
        }, this.props.actionFooter));
      }
      return this.props.menuItems.map(function (option) {
        var optionSelected = _this2.props.highlightSelected && (_this2.props.value === option.displayText || option.selected || _this2.props.value === option.itemId);
        return /*#__PURE__*/React.createElement("div", {
          className: "tl-menu-list-option ".concat(_this2.props.optionClassName, " ").concat(optionSelected ? "tl-option-selected" : ''),
          role: 'button',
          tabIndex: 0,
          key: "".concat(_this2.props.menuListId, "-").concat(option.itemId),
          id: "".concat(option.itemId),
          onClick: function onClick(e) {
            return _this2.onOptionClick(e, option);
          },
          onKeyDown: _this2.onListKeyDown,
          "data-item": option.itemId,
          "data-optionid": option.optionId
        }, _this2.highlightMatch(option.displayText, option.itemId));
      });
    }
  }]);
  return Menu;
}(React.Component);
exports.Menu = Menu;
_defineProperty(Menu, "defaultProps", void 0);
Menu.defaultProps = defaultProps;